import { requestApi } from '../util/network'
//1.	活动是否开启接口
export const isopenSignact =
    () =>
      requestApi(
        '/Index/isopen_signact',
        'GET',
        {
        }
      )
// 2.	获取展示信息接口;
export const gogetxday =
    (token) =>
      requestApi(
        '/Memberpoints/gogetxday',
        'POST',
        {
			key:token
        }
      )
//3 . 加载日历

export const gopointSignin =
    (token,day) =>
      requestApi(
        '/Memberpoints/gopoints_signin',
        'POST',
        {
			key:token,
			search_day:day
        }
      )
//4.	奖品详情信息接口
export const gogetprizeinfo =
    (token,id) =>
      requestApi(
        '/Memberpoints/gogetprizeinfo',
        'POST',
        {
			key:token,
			id:id
        }
      )
//5.	进行今日签到接口
export const gosignin =
    (token) =>
      requestApi(
        '/Memberpoints/gosignin_add',
        'POST',
        {
			key:token
        }
      )
//6.	实物商品订单列表接口
export const gosignOrderList =
    (token,page,shipp,per_page) =>
      requestApi(
        '/Memberpoints/gosign_order_list',
        'POST',
        {
			key:token,
			page:page,
			shipp:shipp,
			per_page:per_page
        }
      )
//7.	实物商品订单详情接口
export const gosignOrderDetail =
    (token,id) =>
      requestApi(
        '/Memberpoints/gosign_order_detail',
        'GET',
        {
			key:token,
			id:id
        }
      )